import {
    CONTENT_GROUP_TYPE,
    CONTENT_DETAIL_KEY,
    CONTENT_GROUP_DETAIL_KEY,
    CONTENT_GROUP_TYPES_WITH_SORTING,
} from '../constants/cycleDetail';

function sortByOrder(arr) {
    return (arr || []).slice().sort((a, b) => (a.order || 0) - (b.order || 0));
}

function sortContentGroupDetails(type, details) {
    const groupKey = CONTENT_GROUP_DETAIL_KEY[type];
    if (!groupKey || !details?.[groupKey]) return details;

    const sortedGroup = sortByOrder(details[groupKey]).map((group) => {
        if (type === CONTENT_GROUP_TYPE.requirements && group.content) {
            group.content = sortByOrder(group.content);
        }
        if (type === CONTENT_GROUP_TYPE.steps) {
            group.settings = sortByOrder(group.settings);
            group.context = sortByOrder(group.context);
        }
        if (type === CONTENT_GROUP_TYPE.tags && group.content) {
            group.content = sortByOrder(group.content);
        }
        return group;
    });

    return { ...details, [groupKey]: sortedGroup };
}

export function sortStageContent(stage) {
    const statusKey = stage?.stage_status?.status_key;
    const stageType = stage?.type;
    const detailKey = CONTENT_DETAIL_KEY?.[stageType]?.[statusKey];

    if (!detailKey || !stage?.default_version?.details?.[detailKey]) {
        return stage;
    }

    const outline = sortByOrder(stage.default_version.details[detailKey]).map((block) => {
        if (!CONTENT_GROUP_TYPES_WITH_SORTING.includes(block.type)) return block;

        const sortedDetails = sortContentGroupDetails(block.type, block.details);
        return {
            ...block,
            details: sortedDetails,
        };
    });

    return {
        ...stage,
        default_version: {
            ...stage.default_version,
            details: {
                ...stage.default_version.details,
                [detailKey]: outline,
            },
        },
    };
}

export function sortCycleBackendResponse(cycle) {
    const sortedCurrentStage = cycle.current_stage ? sortStageContent(cycle.current_stage) : null;

    return { ...cycle, current_stage: sortedCurrentStage };
}
